/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/consistent-indexed-object-style */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subject, BehaviorSubject, firstValueFrom } from 'rxjs';
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private httpClient: HttpClient, private router: Router) { }

	public API_URL = environment.API_URL;

	private userDataSubject = new BehaviorSubject<any>(null);
	userData$ = this.userDataSubject.asObservable();
	setUserData(data: any): void {
		this.userDataSubject.next(data);
	}

	private userListSubject = new BehaviorSubject<any>(null);
	userList$ = this.userListSubject.asObservable();
	setUserList(data: any): void {
		this.userListSubject.next(data);
	}

	private departmentListSubject = new BehaviorSubject<any>(null);
	departmentList$ = this.departmentListSubject.asObservable();
	setDepartmentList(data: any): void {
		this.departmentListSubject.next(data);
	}

	getDateStringFromDate(date: any, format: string): string | null {
		if (!date) {
			return null;
		}
		if (typeof date === 'string' || typeof date === 'number') {
			date = new Date(date);
		}
		if (!(date instanceof Date) || isNaN(date.getTime())) {
			return null;
		}
		const formattedDate = moment(date).format(format);
		return formattedDate;
	}

	getDateFromDateString(date: any, format: string) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		date = moment(date, format);
		if (date.isValid()) {
			return date.toDate();
		} else {
			return null;
		}
	}

	getTimeFromTimeString(timeStr: string) {
		if (!timeStr) {
			return null;
		}
		let arr = timeStr.split(":");
		return { hour: parseInt(arr[0]), minute: parseInt(arr[1]), second: 0 };
	}

	getTimeStringFromTime(dateObj: any) {
		if (dateObj == "" || dateObj == null || dateObj == undefined) {
			return null;
		}
		let hour = dateObj.hour + "";
		let minutes = dateObj.minute + "";
		let seconds = dateObj.second + "";
		hour = this.checkZero(hour);
		minutes = this.checkZero(minutes);
		seconds = this.checkZero(seconds);
		return hour + ":" + minutes + ":" + seconds;
	}

	checkZero(data: any) {
		if (data != undefined && data.toString().length == 1) {
			data = "0" + data;
		}
		return data;
	}

	public getHomeURL() {
		return "/" + this.getNavbar() + "/dashboard";
	}

	public getNavbar() {
		return "app";
	}

	navigateToLogin(storeState: boolean) {
		localStorage.clear();
		if (storeState) {
			this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
		} else {
			this.router.navigate(['/login']);
		}
	}

	public loginAPI(user: any) {
		return this.httpClient.post(this.API_URL + "mdm/login", user);
	}

	public sendResetPasswordLink(data: any) {
		return this.httpClient.post(this.API_URL + "api/sendResetPasswordLink/", data);
	}

	public setNewPassowrd(data: any) {
		return this.httpClient.post(this.API_URL + "api/setPassowrd/", data);
	}

	public checkLinkExpiry(data: any) {
		return this.httpClient.post(this.API_URL + "api/checkLinkExpiry/", data);
	}

	public resetPassword(data: any) {
		return this.httpClient.post(this.API_URL + "api/changePassword/", data);
	}

	public reset2fa(data: any) {
		return this.httpClient.post(this.API_URL + "api/reset2fa", data);
	}

	public generate_qr(data: any) {
		return this.httpClient.post(this.API_URL + "api/generate_qr", data, { responseType: "blob" });
	}

	public loginByMFA(data: any) {
		return this.httpClient.post(`${this.API_URL}mdm/respond_to_auth_challenge`, data);
	}

	public getAllUserList() {
		return this.httpClient.get(this.API_URL + "mdm/users");
	}

	public getUserAndAllUsers(): Observable<unknown> {
		let responses: any = [];
		let response1 = this.httpClient.get(this.API_URL + "mdm/user_details");
		let response2 = this.httpClient.get(this.API_URL + "mdm/users");
		let response3 = this.httpClient.get(this.API_URL + "mdm/department");;
		responses.push(response1, response2, response3);
		return forkJoin(responses);
	}

	public encrypt(list: any[]) {
		return this.httpClient.post(this.API_URL + "mdm/encrypt", { objs: list });
	}

	public decrypt(list: any[]) {
		return this.httpClient.post(this.API_URL + "mdm/decrypt", { objs: list });
	}

	public encryptMultiple(lists: any): Observable<unknown> {
		let responses: any = [];
		for (let i = 0; i < lists.length; i++) {
			let list = lists[i];
			let response = this.httpClient.post(this.API_URL + "mdm/encrypt", { objs: list });
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public decryptMultiple(lists: any): Observable<unknown> {
		let responses: any = [];
		for (let i = 0; i < lists.length; i++) {
			let list = lists[i];
			let response = this.httpClient.post(this.API_URL + "mdm/decrypt", { objs: list });
			responses.push(response);
		}
		return forkJoin(responses);
	}

	async decryptAsync(list: any[]): Promise<any> {
		try {
			const data = await firstValueFrom(this.httpClient.post(this.API_URL + "mdm/decrypt", { objs: list }));
			return data;
		} catch (err) {
			throw err;
		}
	}

	public getAllTaskStatusList() {
		return this.httpClient.get(this.API_URL + "mdm/task_status");
	}

	public getTask(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/task", { params: new HttpParams(httpParams) });
	}

	public createUpdateTask(data: any) {
		const url = this.API_URL + "mdm/task";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteTask(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/task", { params: new HttpParams(httpParams) });
	}

	public getTaskComments(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/task_comments", { params: new HttpParams(httpParams) });
	}

	public createUpdateTaskComment(data: any) {
		const url = this.API_URL + "mdm/task_comments";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteTaskComment(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/task_comments", { params: new HttpParams(httpParams) });
	}

	public getNews(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/company_news", { params: new HttpParams(httpParams) });
	}

	public createUpdateNews(data: any) {
		const url = this.API_URL + "mdm/company_news";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteNews(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/company_news", { params: new HttpParams(httpParams) });
	}

	public commentFileUpload(data: any) {
		return this.httpClient.post(this.API_URL + "mdm/task_files", data);
	}

	public deleteCommentFile(file: any) {
		const httpParams: HttpParamsOptions = { fromObject: { file: file } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/task_files", { params: new HttpParams(httpParams) });
	}

	public getTasksExcel(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/task_excel", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public getRecTask(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/recurring_task", { params: new HttpParams(httpParams) });
	}

	public createUpdateRecTask(data: any) {
		const url = this.API_URL + "mdm/recurring_task";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteRecTask(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/recurring_task", { params: new HttpParams(httpParams) });
	}

	public getAttendance(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/attendance_api", { params: new HttpParams(httpParams) });
	}

	public getLeaves(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/on_leave_employee", { params: new HttpParams(httpParams) });
	}

	public checkLeave(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/check_leave", { params: new HttpParams(httpParams) });
	}

	public checkHoliday(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/check_holiday", { params: new HttpParams(httpParams) });
	}

	public getRegularization(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/regularization", { params: new HttpParams(httpParams) });
	}

	public createUpdateRegularization(data: any) {
		const url = this.API_URL + "mdm/regularization";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteRegularization(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/regularization", { params: new HttpParams(httpParams) });
	}

	public approveRegularization(date: any) {
		return this.httpClient.put(this.API_URL + "mdm/approve_regularization", date);
	}

	public getLeave(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/leave", { params: new HttpParams(httpParams) });
	}

	public createUpdateLeave(data: any) {
		const url = this.API_URL + "mdm/leave";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteLeave(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/leave", { params: new HttpParams(httpParams) });
	}

	public approveLeave(date: any) {
		return this.httpClient.put(this.API_URL + "mdm/approve_leave", date);
	}

	public getAllLeaveTypes() {
		return this.httpClient.get(this.API_URL + "mdm/leave_types");
	}

	public getRoster(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/roaster", { params: new HttpParams(httpParams) });
	}

	public getLastRosterByEmpCode(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/copy_roaster", { params: new HttpParams(httpParams) });
	}

	public createUpdateRoster(data: any[]) {
		const url = this.API_URL + "mdm/roaster";
		if (data[0].id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteRoster(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/roaster", { params: new HttpParams(httpParams) });
	}

	public getTasks(data: any) {
		return this.httpClient.post(this.API_URL + "mdm/task_list", data);
	}

	public changeUserColor(data: any) {
		return this.httpClient.put(this.API_URL + "mdm/assign_color", data);
	}

	public getAttendanceAll(data: any, isExcel: boolean) {
		if (isExcel) {
			data["type"] = "excel";
			return this.httpClient.post(this.API_URL + "mdm/all_emp_attendace", data, { observe: 'response', responseType: 'arraybuffer' });
		} else {
			data["type"] = "list";
			return this.httpClient.post(this.API_URL + "mdm/all_emp_attendace", data);
		}
	}

	public setLeaveBalance(data: any) {
		return this.httpClient.put(this.API_URL + "mdm/set_leave_balance", data);
	}

	public getHoliday(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/holiday", { params: new HttpParams(httpParams) });
	}

	public createUpdateHoliday(data: any) {
		const url = this.API_URL + "mdm/holiday";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteHoliday(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/holiday", { params: new HttpParams(httpParams) });
	}

	public getEvent(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "mdm/events", { params: new HttpParams(httpParams) });
	}

	public createUpdateEvent(data: any) {
		const url = this.API_URL + "mdm/events";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteEvent(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "mdm/events", { params: new HttpParams(httpParams) });
	}
}

export interface HttpParamsOptions {
	fromString?: string;
	fromObject?: {
		[param: string]: string | string[];
	};
	encoder?: HttpParameterCodec;
}

interface HttpParameterCodec {
	encodeKey(key: string): string
	encodeValue(value: string): string
	decodeKey(key: string): string
	decodeValue(value: string): string
}